{
  "brand": "BUG DOS",
  "copyright": "© {{year}} BUG DOS. Bảo lưu mọi quyền.",

  "avatar": {
    "title": "Ảnh đại diện",
    "hint": "JPEG hoặc PNG, tối đa 10MB. Ảnh sẽ được cắt vuông trước khi lưu.",
    "upload": "Tải ảnh",
    "change": "Đổi ảnh",
    "remove": "Xóa ảnh",
    "cropTitle": "Cắt ảnh đại diện",
    "cropHint": "Kéo để căn vùng hiển thị. Ảnh sẽ được lưu dạng vuông.",
    "cropZoom": "Thu phóng",
    "cropCancel": "Hủy",
    "cropConfirm": "Lưu ảnh",
    "uploadSuccess": "Đã cập nhật ảnh đại diện",
    "uploadDisplayFailed": "Đã lưu ảnh nhưng không hiển thị được — thử tải lại trang",
    "uploadFailed": "Không thể tải ảnh lên",
    "removeSuccess": "Đã xóa ảnh đại diện",
    "removeFailed": "Không thể xóa ảnh đại diện"
  },

  "login": {
    "title": "Đăng nhập",
    "username": "Tên đăng nhập",
    "password": "Mật khẩu",
    "usernamePlaceholder": "Nhập tên đăng nhập, email hoặc số điện thoại",
    "passwordPlaceholder": "Nhập mật khẩu",
    "submit": "Đăng nhập",
    "submitting": "Đang đăng nhập...",
    "forgotPassword": "Quên mật khẩu",
    "needAccount": "Cần tài khoản? Liên hệ quản trị viên tổ chức của bạn.",
    "togglePassword": "Hiện/ẩn mật khẩu",
    "twoFactorTitle": "Xác thực hai yếu tố",
    "twoFactorSubtitle": "Nhập mã 6 số từ ứng dụng Authenticator hoặc mã dự phòng",
    "twoFactorCode": "Mã xác minh",
    "twoFactorSubmit": "Xác minh",
    "twoFactorSubmitting": "Đang xác minh...",
    "twoFactorBack": "Quay lại đăng nhập",
    "rememberDevice": "Tin cậy thiết bị này trong 30 ngày",
    "hero": {
      "headlineBefore": "Everything you need for",
      "headlineAfter": "is in one place.",
      "headlineAria": "Everything you need for CRM, EHR, CHAT, CS, HRM, DMS and FUNDS is in one place.",
      "tagline": "Simple by default. Flexible by design.",
      "words": {
        "crm": "CRM",
        "ehr": "EHR",
        "chat": "CHAT",
        "cs": "CS",
        "hrm": "HRM",
        "dms": "DMS",
        "funds": "FUNDS"
      }
    }
  },

  "forgotPassword": {
    "title": "Quên mật khẩu",
    "subtitle": "Nhập tên đăng nhập, email hoặc số điện thoại để nhận liên kết đặt lại mật khẩu",
    "identifier": "Tên đăng nhập, email hoặc số điện thoại",
    "identifierPlaceholder": "Nhập tên đăng nhập, email hoặc số điện thoại",
    "submit": "Gửi liên kết đặt lại",
    "submitting": "Đang gửi...",
    "success": "Đã gửi liên kết đặt lại mật khẩu tới email của bạn. Vui lòng kiểm tra hộp thư.",
    "rememberPassword": "Nhớ mật khẩu rồi?",
    "backToLogin": "Quay lại đăng nhập"
  },

  "resetPassword": {
    "title": "Đặt lại mật khẩu",
    "subtitle": "Nhập mật khẩu mới",
    "newPassword": "Mật khẩu mới",
    "confirmPassword": "Xác nhận mật khẩu mới",
    "submit": "Đặt lại mật khẩu",
    "success": "Đặt lại mật khẩu thành công! Đang chuyển tới trang đăng nhập...",
    "rememberPassword": "Nhớ mật khẩu rồi?",
    "backToLogin": "Quay lại đăng nhập",
    "togglePassword": "Hiện/ẩn mật khẩu",
    "toggleConfirmPassword": "Hiện/ẩn xác nhận mật khẩu"
  },

  "passwordField": {
    "generate": "Tạo mật khẩu",
    "generateTooltip": "Tạo mật khẩu ngẫu nhiên theo chính sách tổ chức",
    "toggleVisibility": "Hiện/ẩn mật khẩu"
  },

  "changePassword": {
    "title": "Đổi mật khẩu",
    "securityNoticeBody": "Vì lý do bảo mật, vui lòng đổi mật khẩu tạm thời thành mật khẩu mới để tiếp tục.",
    "currentPassword": "Mật khẩu hiện tại",
    "currentPasswordPlaceholder": "Nhập mật khẩu hiện tại",
    "newPassword": "Mật khẩu mới",
    "newPasswordPlaceholder": "Nhập mật khẩu mới",
    "confirmPassword": "Xác nhận mật khẩu mới",
    "confirmPasswordPlaceholder": "Nhập lại mật khẩu mới",
    "togglePassword": "Hiện/ẩn mật khẩu",
    "toggleConfirmPassword": "Hiện/ẩn xác nhận mật khẩu",
    "rules": {
      "min": "{{min}}–{{max}} ký tự",
      "uppercase": "Chữ hoa",
      "lowercase": "Chữ thường",
      "number": "Chữ số",
      "special": "Ký tự đặc biệt",
      "match": "Khớp mật khẩu mới"
    },
    "submit": "Đổi mật khẩu",
    "submitting": "Đang đổi mật khẩu...",
    "footer": "Sau khi đổi mật khẩu, bạn sẽ được chuyển hướng để tiếp tục.",
    "fillAllFields": "Vui lòng điền đầy đủ các trường",
    "passwordsDoNotMatch": "Mật khẩu mới không khớp",
    "success": "Đổi mật khẩu thành công!",
    "failed": "Đổi mật khẩu thất bại"
  },

  "validation": {
    "usernameRequired": "Vui lòng nhập tên đăng nhập, email hoặc số điện thoại",
    "passwordRequired": "Vui lòng nhập mật khẩu",
    "passwordMin6": "Mật khẩu phải có ít nhất 6 ký tự",
    "passwordMin8": "Mật khẩu phải có ít nhất 8 ký tự",
    "passwordMinN": "Mật khẩu phải có ít nhất {{count}} ký tự",
    "passwordMaxN": "Mật khẩu không được quá {{count}} ký tự",
    "passwordComplexity": "Mật khẩu phải có ít nhất một chữ hoa, một chữ thường, một số và một ký tự đặc biệt",
    "passwordUppercase": "Mật khẩu phải có ít nhất một chữ hoa",
    "passwordLowercase": "Mật khẩu phải có ít nhất một chữ thường",
    "passwordNumber": "Mật khẩu phải có ít nhất một số",
    "passwordSpecial": "Mật khẩu phải có ít nhất một ký tự đặc biệt (@$!%*?&)",
    "confirmPasswordRequired": "Vui lòng xác nhận mật khẩu",
    "passwordsMustMatch": "Mật khẩu không khớp"
  },

  "roles": {
    "admin": "Quản trị",
    "member": "Thành viên",
    "manager": "Quản lý",
    "dentist": "Bác sĩ",
    "receptionist": "Lễ tân",
    "assistant": "Phụ tá"
  },

  "clinicAccess": {
    "type": "Kiểu truy cập phòng khám",
    "allClinics": "Tất cả phòng khám",
    "subset": "Một số phòng khám",
    "accessibleClinics": "Phòng khám được truy cập",
    "selectClinics": "Chọn phòng khám",
    "clinicsRequired": "Vui lòng chọn ít nhất một phòng khám",
    "unknownClinic": "Không xác định"
  },

  "users": {
    "pages": {
      "listTitle": "Người dùng",
      "permissionDenied": "Bạn không có quyền quản lý tài khoản."
    },
    "filters": {
      "searchPlaceholder": "Tìm theo tên, email, SĐT, tên đăng nhập..."
    },
    "table": {
      "username": "Tên đăng nhập",
      "name": "Họ tên",
      "email": "Email",
      "phone": "Số điện thoại",
      "systemRole": "Loại tài khoản",
      "permissionGroup": "Vai trò",
      "clinicAccess": "Truy cập phòng khám",
      "status": "Trạng thái",
      "lastLogin": "Đăng nhập lần cuối",
      "twoFactor": "2FA",
      "createdAt": "Ngày tạo",
      "createdBy": "Người tạo",
      "updatedAt": "Ngày chỉnh sửa",
      "updatedBy": "Người chỉnh sửa"
    },
    "empty": {
      "noMatch": "Không có người dùng khớp tìm kiếm",
      "none": "Không tìm thấy người dùng"
    },
    "actions": {
      "createUser": "Tạo người dùng",
      "editUser": "Sửa người dùng",
      "deleteUser": "Xóa người dùng",
      "unlockUser": "Mở khóa tài khoản",
      "deactivateUser": "Vô hiệu hóa",
      "activateUser": "Kích hoạt lại",
      "revokeSessions": "Đăng xuất tất cả phiên",
      "resetTwoFactor": "Reset 2FA",
      "creating": "Đang tạo...",
      "updating": "Đang cập nhật...",
      "unlocking": "Đang mở khóa...",
      "deactivating": "Đang vô hiệu hóa...",
      "activating": "Đang kích hoạt...",
      "revokingSessions": "Đang thu hồi phiên...",
      "resettingTwoFactor": "Đang reset 2FA...",
      "deleting": "Đang xóa...",
      "updateUser": "Cập nhật người dùng"
    },
    "status": {
      "active": "Hoạt động",
      "inactive": "Vô hiệu hóa",
      "locked": "Bị khóa",
      "lockedUntil": "Bị khóa đến {{time}}",
      "twoFactorOn": "Đã bật 2FA",
      "twoFactorOff": "Chưa bật 2FA"
    },
    "lastLogin": {
      "never": "Chưa từng"
    },
    "a11y": {
      "usersTable": "Bảng người dùng",
      "userActions": "Thao tác người dùng"
    },
    "fields": {
      "staffMember": "Nhân viên",
      "selectStaff": "Chọn nhân viên",
      "staffFallback": "Nhân viên",
      "staffOption": "{{name}} ({{designation}})",
      "username": "Tên đăng nhập",
      "usernamePlaceholder": "Nhập tên đăng nhập",
      "temporaryPassword": "Mật khẩu tạm",
      "temporaryPasswordPlaceholder": "Nhập mật khẩu tạm",
      "temporaryPasswordHelper": "Người dùng sẽ phải đổi mật khẩu này khi đăng nhập lần đầu",
      "systemRole": "Loại tài khoản",
      "permissionGroup": "Vai trò",
      "selectPermissionGroup": "Chọn vai trò",
      "role": "Vai trò",
      "accountTypeHelper": "Chỉ chọn Admin khi cần toàn quyền hệ thống. Quyền chi tiết lấy từ Vai trò.",
      "roleRequired": "Vui lòng chọn vai trò"
    },
    "alerts": {
      "allStaffHaveAccounts": "Tất cả nhân viên đã có tài khoản. Vui lòng tạo hồ sơ Nhân viên mới trước."
    },
    "sections": {
      "userProfileHint": "Hồ sơ người dùng",
      "personalPermissionOverrides": "Quyền bổ sung",
      "permissionOverridesHint": "Ô xám đã có từ Vai trò. Tick thêm để cấp quyền bổ sung cho người này.",
      "adminAllPermissions": "Loại tài khoản Admin có toàn quyền hệ thống — không cần cấp quyền bổ sung."
    },
    "permissionSource": {
      "fromRole": "Từ vai trò",
      "override": "Bổ sung"
    },
    "dialogs": {
      "createTitle": "Tạo người dùng mới",
      "editTitle": "Sửa người dùng",
      "deleteTitle": "Xóa người dùng",
      "deleteConfirm": "Bạn có chắc muốn xóa người dùng \"{{name}}\"? Hành động này không thể hoàn tác.",
      "revokeSessionsTitle": "Thu hồi tất cả phiên",
      "revokeSessionsConfirm": "Thu hồi mọi phiên đăng nhập của \"{{name}}\"? Người dùng sẽ phải đăng nhập lại.",
      "resetTwoFactorTitle": "Reset xác thực hai yếu tố",
      "resetTwoFactorConfirm": "Reset 2FA của \"{{name}}\"? Người dùng sẽ bị đăng xuất và phải thiết lập lại 2FA.",
      "thisUser": "người dùng này"
    },
    "validation": {
      "staffRequired": "Vui lòng chọn nhân viên",
      "usernameRequired": "Vui lòng nhập tên đăng nhập",
      "usernameMin": "Tên đăng nhập phải có ít nhất {{min}} ký tự",
      "usernameMax": "Tên đăng nhập không được quá {{max}} ký tự",
      "passwordRequired": "Vui lòng nhập mật khẩu tạm",
      "permissionGroupRequired": "Vui lòng chọn vai trò"
    },
    "toasts": {
      "loadOrgFailed": "Không tải được tổ chức",
      "loadFailed": "Không tải được dữ liệu nhóm",
      "loadUserFailed": "Không tải được thông tin người dùng",
      "selectStaff": "Vui lòng chọn nhân viên",
      "selectPermissionGroup": "Vui lòng chọn vai trò",
      "createSuccess": "Tạo người dùng thành công",
      "createFailed": "Tạo người dùng thất bại",
      "updateSuccess": "Cập nhật người dùng thành công",
      "updateFailed": "Cập nhật người dùng thất bại",
      "unlockSuccess": "Đã mở khóa tài khoản",
      "unlockFailed": "Mở khóa tài khoản thất bại",
      "deactivateSuccess": "Đã vô hiệu hóa tài khoản",
      "deactivateFailed": "Vô hiệu hóa tài khoản thất bại",
      "activateSuccess": "Đã kích hoạt lại tài khoản",
      "activateFailed": "Kích hoạt tài khoản thất bại",
      "revokeSessionsSuccess": "Đã thu hồi {{count}} phiên đăng nhập",
      "revokeSessionsFailed": "Thu hồi phiên đăng nhập thất bại",
      "resetTwoFactorSuccess": "Đã reset 2FA (thu hồi {{count}} phiên)",
      "resetTwoFactorFailed": "Reset 2FA thất bại",
      "deleteSuccess": "Xóa người dùng thành công",
      "deleteFailed": "Xóa người dùng thất bại"
    }
  },

  "permissionGroups": {
    "names": {
      "adminGroup": "Quản trị viên",
      "managerGroup": "Quản lý",
      "dentistGroup": "Bác sĩ",
      "receptionistGroup": "Lễ tân",
      "assistantGroup": "Phụ tá",
      "marketingGroup": "Marketing",
      "customerServiceGroup": "Chăm sóc khách hàng",
      "accountingGroup": "Kế toán",
      "housekeeperGroup": "Tạp vụ"
    },
    "descriptions": {
      "adminGroup": "Toàn quyền truy cập mọi chức năng hệ thống",
      "managerGroup": "Quản lý vận hành và cấu hình phòng khám",
      "dentistGroup": "Hồ sơ y tế, kế hoạch điều trị và bệnh nhân",
      "receptionistGroup": "Tiếp nhận bệnh nhân, lịch hẹn và thanh toán",
      "assistantGroup": "Xem lịch điều trị và thông tin bệnh nhân cơ bản",
      "marketingGroup": "Leads, nguồn khách, khuyến mãi và truyền thông",
      "customerServiceGroup": "Hộp thư, leads, lịch hẹn và hỗ trợ bệnh nhân",
      "accountingGroup": "Thu chi, sổ quỹ, hoa hồng và báo cáo tài chính",
      "housekeeperGroup": "Chấm công, nghỉ phép và công việc nội bộ (tạp vụ, bếp…)"
    },
    "pages": {
      "listTitle": "Vai trò",
      "permissionDenied": "Bạn không có quyền quản lý vai trò."
    },
    "table": {
      "name": "Tên vai trò",
      "description": "Mô tả",
      "permissionCount": "Số lượng quyền hạn",
      "activeCount": "{{count}} quyền được kích hoạt"
    },
    "empty": {
      "none": "Chưa có vai trò nào được cấu hình"
    },
    "actions": {
      "create": "Tạo vai trò",
      "createGroup": "Tạo vai trò",
      "saveChanges": "Lưu thay đổi",
      "saving": "Đang lưu...",
      "deleting": "Đang xóa...",
      "editTooltip": "Chỉnh sửa vai trò",
      "deleteTooltip": "Xóa vai trò"
    },
    "a11y": {
      "edit": "Chỉnh sửa vai trò",
      "delete": "Xóa vai trò"
    },
    "fields": {
      "name": "Tên vai trò (ví dụ: Kế toán, Marketing)",
      "description": "Mô tả công việc / phạm vi áp dụng",
      "copyFrom": "Sao chép quyền từ mẫu",
      "copyFromNone": "Bắt đầu trống"
    },
    "sections": {
      "rbacMatrix": "Cấu hình ma trận quyền hạn (RBAC Matrix)",
      "module": "Module: {{moduleName}}"
    },
    "dialogs": {
      "createTitle": "Tạo vai trò mới",
      "editTitle": "Chỉnh sửa vai trò",
      "deleteTitle": "Xóa vai trò",
      "deleteConfirm": "Bạn có chắc muốn xóa vai trò \"{{name}}\"? Thao tác này không thể hoàn tác.",
      "thisGroup": "này"
    },
    "toasts": {
      "loadFailed": "Không tải được danh sách vai trò",
      "nameRequired": "Vui lòng nhập tên vai trò",
      "updateSuccess": "Đã cập nhật vai trò",
      "createSuccess": "Đã tạo vai trò",
      "saveFailed": "Lưu vai trò thất bại",
      "deleteSuccess": "Xóa vai trò thành công",
      "deleteFailed": "Xóa vai trò thất bại"
    }
  },

  "profile": {
    "pages": {
      "title": "Hồ sơ nhân sự",
      "loading": "Đang tải hồ sơ..."
    },
    "tabs": {
      "personal": "Hồ sơ",
      "account": "Bảo mật",
      "preferences": "Tùy chọn",
      "clock": "Chấm công",
      "attendance": "Chấm công",
      "attendanceHistory": "Lịch sử chấm công",
      "schedule": "Lịch của tôi",
      "timeOff": "Nghỉ phép",
      "timeOffRequest": "Xin nghỉ phép",
      "journal": "Nhật ký điều trị",
      "payslips": "Phiếu lương",
      "advances": "Tạm ứng"
    },
    "work": {
      "scheduleHint": "Xem lịch làm việc cá nhân trên lịch team (đã lọc theo bạn).",
      "openSchedule": "Mở lịch của tôi"
    },
    "actions": {
      "edit": "Sửa",
      "save": "Lưu thay đổi",
      "saving": "Đang lưu...",
      "cancel": "Hủy",
      "changePassword": "Đổi mật khẩu",
      "changingPassword": "Đang đổi mật khẩu...",
      "logoutAllDevices": "Đăng xuất tất cả"
    },
    "notices": {
      "fieldNotSupported": "Chưa hỗ trợ lưu trên hệ thống",
      "personalReadOnly": "Đây là hồ sơ của bạn (chỉ xem). Mọi thay đổi do bộ phận nhân sự cập nhật.",
      "noStaffProfile": "Tài khoản chưa liên kết hồ sơ nhân sự. Chỉ hiển thị thông tin đăng nhập cơ bản.",
      "usernameReadOnly": "Tên đăng nhập không thể thay đổi tại đây.",
      "roleReadOnly": "Loại tài khoản do quản trị viên gán.",
      "preferencesUnavailable": "Ngôn ngữ, giao diện, thông báo và định dạng giờ chưa được lưu trên máy chủ. Thay đổi tạm thời sẽ không được giữ lại.",
      "securityUnavailable": "Xác thực hai yếu tố và hết phiên chưa được hỗ trợ. Bạn vẫn có thể quản lý phiên đăng nhập bên dưới."
    },
    "a11y": {
      "tabs": "Tab hồ sơ",
      "togglePassword": "Hiện/ẩn mật khẩu"
    },
    "sections": {
      "personal": "Hồ sơ",
      "account": "Tài khoản",
      "changePassword": "Đổi mật khẩu",
      "preferences": "Tùy chọn",
      "notifications": "Thông báo",
      "security": "Cài đặt bảo mật",
      "securityAdvanced": "Bảo mật nâng cao",
      "securityInfo": "Thông tin bảo mật"
    },
    "fields": {
      "firstName": "Tên",
      "lastName": "Họ",
      "email": "Email",
      "phone": "Số điện thoại",
      "address": "Địa chỉ",
      "city": "Thành phố",
      "state": "Tỉnh/Thành",
      "zipCode": "Mã bưu điện",
      "country": "Quốc gia",
      "role": "Vai trò hệ thống",
      "staffCode": "Mã nhân viên",
      "department": "Phòng ban",
      "designation": "Chức danh",
      "status": "Trạng thái",
      "bio": "Giới thiệu",
      "username": "Tên đăng nhập",
      "currentPassword": "Mật khẩu hiện tại",
      "newPassword": "Mật khẩu mới",
      "confirmPassword": "Xác nhận mật khẩu mới",
      "language": "Ngôn ngữ",
      "selectLanguage": "Chọn ngôn ngữ",
      "theme": "Giao diện",
      "selectTheme": "Chọn giao diện",
      "timeFormat": "Định dạng giờ",
      "selectTimeFormat": "Chọn định dạng giờ",
      "sessionTimeout": "Hết phiên (phút)"
    },
    "languages": {
      "en": "Tiếng Anh",
      "hi": "Tiếng Hindi",
      "es": "Tiếng Tây Ban Nha",
      "fr": "Tiếng Pháp",
      "de": "Tiếng Đức"
    },
    "themes": {
      "light": "Sáng",
      "dark": "Tối",
      "system": "Theo hệ thống"
    },
    "timeFormats": {
      "h12": "12 giờ (AM/PM)",
      "h24": "24 giờ"
    },
    "notifications": {
      "email": "Thông báo email",
      "sms": "Thông báo SMS",
      "app": "Thông báo trong ứng dụng"
    },
    "security": {
      "twoFactor": "Xác thực hai yếu tố",
      "twoFactorHelp": "Thêm lớp bảo mật bằng cách yêu cầu mã xác minh ngoài mật khẩu khi đăng nhập.",
      "twoFactorEnabled": "Đã bật",
      "twoFactorDisabled": "Chưa bật",
      "setup": "Thiết lập 2FA",
      "setupTitle": "Thiết lập xác thực hai yếu tố",
      "setupScan": "Quét mã QR bằng ứng dụng Authenticator (Google Authenticator, Microsoft Authenticator, Authy…)",
      "setupManual": "Hoặc nhập mã thủ công",
      "setupConfirm": "Nhập mã 6 số từ ứng dụng để xác nhận",
      "confirm": "Xác nhận",
      "confirming": "Đang xác nhận...",
      "disable": "Tắt 2FA",
      "disableTitle": "Tắt xác thực hai yếu tố",
      "disableHelp": "Nhập mật khẩu và mã xác minh (hoặc mã dự phòng) để tắt 2FA.",
      "password": "Mật khẩu hiện tại",
      "code": "Mã xác minh",
      "backupCodesTitle": "Mã dự phòng",
      "backupCodesHelp": "Lưu các mã này ở nơi an toàn. Mỗi mã chỉ dùng được một lần khi bạn không có điện thoại.",
      "backupCodesCopied": "Đã sao chép mã dự phòng",
      "copyBackupCodes": "Sao chép",
      "closeBackupCodes": "Đã lưu, đóng",
      "regenerateBackupCodes": "Tạo lại mã dự phòng",
      "regenerateBackupTitle": "Tạo lại mã dự phòng",
      "regenerateBackupHelp": "Nhập mật khẩu và mã Authenticator (hoặc mã dự phòng còn lại). Bộ mã cũ sẽ bị hủy ngay.",
      "regenerateBackupSuccess": "Đã tạo bộ mã dự phòng mới",
      "regenerateBackupFailed": "Tạo lại mã dự phòng thất bại",
      "regenerating": "Đang tạo lại...",
      "setupSuccess": "Đã bật xác thực hai yếu tố",
      "setupFailed": "Thiết lập 2FA thất bại",
      "confirmFailed": "Xác nhận 2FA thất bại",
      "disableSuccess": "Đã tắt xác thực hai yếu tố",
      "disableFailed": "Tắt 2FA thất bại",
      "mustEnrollTitle": "Yêu cầu bật xác thực hai yếu tố",
      "mustEnrollHelp": "Tổ chức của bạn yêu cầu bật 2FA trước khi tiếp tục sử dụng hệ thống.",
      "lastPasswordChange": "Lần đổi mật khẩu gần nhất",
      "lastLogin": "Lần đăng nhập gần nhất",
      "never": "Chưa từng"
    },
    "securityNav": {
      "passwordHint": "Mật khẩu đăng nhập",
      "mfaRequired": "Cần bật",
      "sessionsHint": "{{count}} thiết bị"
    },
    "sessions": {
      "title": "Phiên đăng nhập",
      "help": "Các thiết bị đang đăng nhập vào tài khoản của bạn. Bạn có thể đăng xuất từng thiết bị hoặc tất cả thiết bị khác.",
      "empty": "Không có phiên đăng nhập nào.",
      "current": "Thiết bị hiện tại",
      "unknownDevice": "Thiết bị không xác định",
      "ip": "IP",
      "created": "Bắt đầu",
      "lastSeen": "Hoạt động gần nhất",
      "expires": "Hết hạn",
      "revoke": "Đăng xuất",
      "revoking": "Đang đăng xuất...",
      "loadFailed": "Không tải được danh sách phiên",
      "revokeSuccess": "Đã đăng xuất thiết bị",
      "revokeFailed": "Đăng xuất thiết bị thất bại",
      "revokeOthersSuccess": "Đã đăng xuất {{count}} thiết bị khác",
      "revokeOthersFailed": "Đăng xuất các thiết bị khác thất bại",
      "currentRevoked": "Phiên hiện tại đã được thu hồi. Vui lòng đăng nhập lại."
    },
    "validation": {
      "passwordMismatch": "Mật khẩu không khớp",
      "passwordRequired": "Vui lòng nhập mật khẩu hiện tại và mật khẩu mới"
    },
    "toasts": {
      "loadFailed": "Không tải được dữ liệu hồ sơ",
      "updateSuccess": "Cập nhật hồ sơ thành công",
      "updateFailed": "Cập nhật hồ sơ thất bại",
      "passwordSuccess": "Đổi mật khẩu thành công",
      "passwordFailed": "Đổi mật khẩu thất bại",
      "preferencesNotSaved": "Tùy chọn chưa được hỗ trợ lưu trên máy chủ",
      "securitySettingsNotSaved": "Cài đặt bảo mật này chưa được hỗ trợ"
    }
  },

  "common": {
    "notAvailable": "N/A",
    "thisUser": "người dùng này",
    "authTokenMissing": "Không tìm thấy token xác thực"
  }
}
